<template lang="pug">
  .form-group
    label {{ label }}
    select.form-control(v-model="localData" :class="{'input-error': !isValidInput()}" :disabled="disabled" @change="$emit('update:data', localData, isValidInput())")
      option.option-placeholder(v-if="!isValidInput()" :value="undefined" selected hidden disabled) {{ !isValidInput() ? requiredLabel : '' }}
      option(v-else-if="isValidInput() && !required" :value="null")
      option(v-for="(val, index) in property.enum" :value="val") {{ val }}
</template>

<script>
import Base from '../base'

export default {
  extends: Base,
  accepts(property) {
    return property.enum
  }
}
</script>


// WEBPACK FOOTER //
// src/components/metadataeditor/template/default/Enum.vue